import { render, staticRenderFns } from "./image-loader.vue?vue&type=template&id=0dbbc71c&scoped=true&"
import script from "./image-loader.vue?vue&type=script&lang=js&"
export * from "./image-loader.vue?vue&type=script&lang=js&"
import style0 from "./image-loader.vue?vue&type=style&index=0&id=0dbbc71c&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbbc71c",
  null
  
)

export default component.exports